export default __webpack_public_path__ + "static/Homepage_Awards_Bg-a233b01d9bab5e4e4fdd9399631edaca.webp";